import { render, staticRenderFns } from "./FabricPicking.vue?vue&type=template&id=51b6892c&"
import script from "./FabricPicking.vue?vue&type=script&lang=js&"
export * from "./FabricPicking.vue?vue&type=script&lang=js&"
import style0 from "./FabricPicking.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports